let connect = require("react-redux").connect;
import React from "react";

let actions = require("../actions/actions");
let Loading = require("./loading");
let SuspendedSearch = require("./moderation-suspended-search");
let SuspendedSlats = require("./moderation-suspended-slats");

class ModerationSuspended extends React.Component {
    constructor(props) {
        super(props);
    }

    componentWillMount() {
        this.props.fetchSuspendedUploads("");
    }

    loadMoreUploads() {
        if (
            this.props.batch.result !== "SEARCH_SUSPENDED_UPLOADS_SUCCESS" &&
            this.props.batch.pagination
        ) {
            this.props.fetchSuspendedUploads(
                "",
                this.props.batch.pagination.pageCount + 1
            );
        }
    }

    render() {
        if (this.props.batch.uploads) {
            let button = this.renderButton();

            return (
                <div>
                    <SuspendedSearch />
                    <SuspendedSlats batch={this.props.batch} />
                    {button}
                </div>
            );
        } else {
            return <Loading />;
        }
    }

    renderButton() {
        let button = null;

        if (
            this.props.batch.uploads.length !==
            this.props.batch.totalSuspendedUploads
        ) {
            button = (
                <div>
                    <button
                        className="load-more btn btn-default black"
                        onClick={this.loadMoreUploads.bind(this)}
                    >
                        Load More
                    </button>
                </div>
            );
        }

        return button;
    }
}

function mapStateToProps(state, ownProps) {
    let batch = { uploads: null }, keys;

    if (state.uploads.result) {
        batch.result = state.uploads.result;
    }

    if (state.uploads.result) {
        if (state.uploads.keys) {
            batch.pagination = state.pagination.suspendedUploads[""];

            if (state.uploadsSuspendedSearchKeys.length > 0) {
                batch.uploads = [];
                keys = state.uploadsSuspendedSearchKeys;
            } else if (state.uploadsSuspendedKeys.length > 0) {
                batch.uploads = [];
                keys = state.uploadsSuspendedKeys;
            }

            if (keys) {
                keys.forEach(uploadId => {
                    let upload = state.uploads[uploadId];
                    batch.uploads.push(upload);
                    if (state.uploadsSuspendedSearchKeys.length === 0) {
                        batch.totalSuspendedUploads = state.uploads.counts.suspended_batches;
                    } else {
                        batch.totalSuspendedUploads = state.uploadsSuspendedSearchKeys.length;
                    }
                });
            }
        }
    }

    return { batch };
}

module.exports = connect(mapStateToProps, {
    fetchSuspendedUploads: actions.fetchSuspendedUploads
})(ModerationSuspended);
